import { useEffect } from "react";
import {
  HP_GOOGLE_FONTS_URL,
  HP_HOME_TONE_FONTS_URL,
  INLINE_LOADER,
  TONE_INLINE_LOADER,
  loadHpGoogleFontsAfterLoad,
  loadHpToneFontsAfterLoad,
} from "./deferred-google-fonts";

/* /women トップの Google Fonts を load の後に足す。足し方の決まりは deferred-google-fonts.ts */
/* tone は v2 のトップの見出しと手書きの 2 書体も足すか (お支払いの頁は付けない) */
export function DeferredGoogleFonts({ tone = false }: { tone?: boolean } = {}) {
  useEffect(() => loadHpGoogleFontsAfterLoad(), []);
  useEffect(() => (tone ? loadHpToneFontsAfterLoad() : undefined), [tone]);
  return (
    <>
      <script dangerouslySetInnerHTML={{ __html: INLINE_LOADER }} />
      {tone ? <script dangerouslySetInnerHTML={{ __html: TONE_INLINE_LOADER }} /> : null}
      <noscript>
        <link rel="stylesheet" href={HP_GOOGLE_FONTS_URL} />
        {tone ? <link rel="stylesheet" href={HP_HOME_TONE_FONTS_URL} /> : null}
      </noscript>
    </>
  );
}
